import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    BlockType,
    Setting,
    SettingType,
    Define,
    ValidationMessage,
    SettingState,
    TibboDataType,
    AppBlockPort,
    SettingOption,
} from '@appblocks/codegeneration/types';

export default class TableUpdateFieldValue extends BaseFeature {
    constructor() {
        super();
        this.name = 'Table Update Field Value';
        this.id = 'table_update_field_value';
        this.fileLinks = [

        ];

        const settings = [
            {
                id: 'FIELD',
                name: 'Field',
                settingType: SettingType.OPTION,
                required: true,
                options: [],
                default: '',
            },
            {
                id: 'VALUE',
                name: 'Value',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        if (settingId === 'FIELD') {
            const project = this.project;
            const parent = project.getParent(this);
            // get table from parent
            const table = parent.getSettingValue('TABLE');
            let options = [{
                name: 'Undefined',
                value: '',
            }];
            if (!table) {
                return options;
            }
            const tableFeature = project.getFeature(table);
            if (!tableFeature) {
                return options;
            }
            const fields = tableFeature.getSettingValue('FIELDS');
            if (fields && fields.length > 0) {
                options = options.concat(fields.map((field: any) => ({
                    name: `${field.getSettingValue('NAME')} (${field.getSettingValue('DISPLAY_NAME')})`,
                    value: field.getSettingValue('NAME'),
                })));
                return options;
            }
        }
        return super.getSettingOptions(settingId);
    }

    getInputs(): AppBlockPort[] {
        const project = this.project;
        const parent = project.getParent(this);
        return parent.getInputs();
    }

    getOutputs(): AppBlockPort[] {
        const project = this.project;
        const parent = project.getParent(this);
        return parent.getOutputs();
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        return errors;
    }
}
